module.exports = {"ENV_NAME":"local","LOG_ERRORS":true,"LOG_ERRORS_SENTRY":false,"APP_URL":"https://localhost:3000"}


//////////////////
// WEBPACK FOOTER
// ./src/config/local-deployment.json
// module id = 1325
// module chunks = 0